import {
  Card,
  Col,
  Divider,
  Row,
  Typography,
} from "../../../../components/common/utils/antd-imports/AntdImports";
import { ReactComponent as SuccessIcon } from "../../../../assests/payment-success-icon.svg";
import "../CampaignPayments.css";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { formatToUSCurrency } from "../../../../components/common/utils/Utils";
import {
  addBreadcrumb,
  setBreadcrumbs,
} from "../../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";

const { Text } = Typography;
const PaymentSuccess = ({ type }) => {
  const location = useLocation();
  const { paymentType, stripeResponse } = location.state || "N/A";
  const userRole = useSelector((state) => state.login.userType);
  const navigate = useNavigate();
  const status = stripeResponse?.payload?.status;
  const succPayment = stripeResponse?.payload?.succ_payment;
  const errorPayment = stripeResponse?.payload?.error_payment;
  const total_paid_amounts = stripeResponse?.payload?.total_paid_amount;
  const dispatch = useDispatch();
  const goToSubPage = ({ title, path }) => {
    dispatch(
      setBreadcrumbs([
        {
          title: "Dashboard",
          path: userRole === "owner" ? "/seller/dashboard" : "/buyer/dashboard",
        },
        {
          title: "Campaigns",
          path: `/${userRole}/mycampaigns?segment=saved_campaign`,
        },
        { title, path },
      ])
    );
  };
  return (
    <div className="payment-success-container-div">
      <Card className="payment-success-container-card">
        <Row className="payment-success-icon-row">
          <Col>
            <SuccessIcon />
          </Col>
          <Col className="payment-success-main-text-col">
            <Text className="payment-success-main-text">Payment Success!</Text>
          </Col>
        </Row>
        <Row className="payment-success-divider-row">
          <Divider />
        </Row>
        <Row className="success-total-amount-paid-row">
          <Col className="common-success-total-amount-col">
            <Text className="success-total-amount-paid-label">
              Total Amount Paid
            </Text>
          </Col>
          <Col className="common-success-total-amount-col">
            <Text className="success-total-amount-paid-label-value">
              {formatToUSCurrency(total_paid_amounts?.toFixed(2) || 0)}
            </Text>
          </Col>
        </Row>
        <Row className="success-total-amount-paid-row">
          <Col className="common-success-total-amount-col">
            <Text className="success-total-amount-paid-label">Campaigns</Text>
          </Col>

          <Col className="common-success-total-amount-col-campaign">
            {status === "1" &&
              succPayment?.length > 0 &&
              errorPayment?.length > 0 && (
                <Card className="displaying-total-campaigns-card">
                  <div>
                    <Text type="success">Successful Payments:</Text>
                    {succPayment?.map((id, idx) => (
                      <Row>
                        <Text key={`succ-${idx}`} className="success-text">
                          {id}
                        </Text>
                      </Row>
                    ))}
                  </div>
                  <div>
                    <Text type="danger" className="">
                      Failed Payments:
                    </Text>
                    {errorPayment?.map((id, idx) => (
                      <div className="error-campaigns-div">
                        <Row>
                          <Text key={`error-${idx}`} className="error-text">
                            {id}
                          </Text>
                        </Row>
                      </div>
                    ))}
                  </div>
                </Card>
              )}

            {status === "1" &&
              succPayment?.length > 0 &&
              (!errorPayment || errorPayment?.length === 0) && (
                <>
                  <Text type="success">All payments successful:</Text>
                  {succPayment?.map((id, idx) => (
                    <Text key={`succ-only-${idx}`} className="success-text">
                      {id}
                    </Text>
                  ))}
                </>
              )}
          </Col>
        </Row>
        <Row className="success-total-amount-paid-row">
          <Col className="common-success-total-amount-col">
            <Text className="success-total-amount-paid-label">
              Payment Method
            </Text>
          </Col>
          <Col className="common-success-total-amount-col">
            <Text className="success-total-amount-paid-label-value">
              {paymentType || "N/A"}
            </Text>
          </Col>
        </Row>
        <Row className="payment-success-divider-row">
          <Divider />
        </Row>
        <Row className="payment-success-confirmation-email-row">
          <Text className="payment-success-confirmation-email-text">
            A confirmation email has been sent to your registered email.
          </Text>
        </Row>
        <Row className="payment-success-go-to-dashboard-row">
          <Text
            className="payment-success-go-to-dashboard-text"
            onClick={() => {
              goToSubPage({
                title: "Campaigns",
                path: `${
                  userRole === "owner" ? "/seller" : "/buyer"
                }/mycampaigns?segment=insertion_order`,
              });
              navigate(
                `${
                  userRole === "owner" ? "/seller" : "/buyer"
                }/mycampaigns?segment=insertion_order`
              );
            }}
          >
            Go to Campaigns
          </Text>
        </Row>
      </Card>
    </div>
  );
};
export default PaymentSuccess;
